import CRUD from './genericCRUD'

const route = 'adjustment_event_types'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function adjustmentEventTypes(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route)
	}
}
